import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/periodos/periodos';
import SeleccionarCuenta from './SeleccionarCuentaBancaria';


const ms2p = (state) => {
  return {
    ...state.periodo,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(SeleccionarCuenta);
